<template>
  <v-container>
    <v-dialog v-model="dialog" persistent max-width="400px" class="elevation-0">
      <v-card rounded="xl" flat>
        <v-card-title class="grey">
          <h4 class="text-body-1 text-sm-h6 font-weight-bold">Şifremi Değiştir</h4>

          <v-spacer />

          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            rounded
            small
            depressed
            color="chip"
            class="text-capitalize"
            @click="dialog = false"
          >
            <v-icon left>{{ icons.mdiClose }}</v-icon>
            Kapat
          </v-btn>
          <v-icon v-else small @click="closeSubmit">{{ icons.mdiClose }}</v-icon>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 pa-sm-3 pb-0 pt-3">
          <validation-observer ref="observer">
            <v-container class="pb-0">
              <v-row>
                <v-col cols="12">
                  <validation-provider
                    v-slot="{ errors }"
                    tag="div"
                    mode="eager"
                    name="Eski Şifre"
                    rules="required"
                  >
                    <v-text-field
                      v-model="oldPassword"
                      :error-messages="errors"
                      label="Eski Şifre"
                      rounded
                      filled
                      hide-details
                      type="password"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="12">
                  <validation-provider
                    v-slot="{ errors }"
                    ref="password"
                    tag="div"
                    mode="eager"
                    name="Yeni Şifre"
                    rules="required"
                    vid="confirmation"
                  >
                    <v-text-field
                      v-model="newPassword"
                      :error-messages="errors"
                      label="Yeni Şifre"
                      rounded
                      filled
                      hide-details
                      type="password"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="12">
                  <validation-provider
                    v-slot="{ errors }"
                    tag="div"
                    mode="eager"
                    name="Yeni Şifre Tekrar"
                    rules="confirmed:confirmation"
                  >
                    <v-text-field
                      v-model="confirmPassword"
                      :error-messages="errors"
                      label="Yeni Şifre Tekrar"
                      rounded
                      filled
                      hide-details
                      type="password"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-container>
          </validation-observer>
        </v-card-text>

        <v-card-actions class="pa-0 pa-sm-3 pt-0">
          <v-container class="pt-0" style="z-index: 2">
            <v-row align="center">
              <v-col cols="12" sm="7">
                <v-btn
                  color="secondary"
                  :loading="loading"
                  @click="submit"
                  depressed
                  rounded
                  block
                  x-large
                  class="text-capitalize"
                >
                  Değiştir
                </v-btn>
              </v-col>
              <v-col cols="12" sm="5">
                <v-btn :disabled="loading" plain @click="closeSubmit"> Vazgeç </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col class="d-block d-md-flex justify-center pt-2 pb-6 py-md-16">
        <v-progress-circular v-if="pageLoading" class="el-center" :size="120" indeterminate>
          <span class="text-caption">Yükleniyor</span>
        </v-progress-circular>
        <v-card
          v-if="!pageLoading"
          elevation="16"
          :rounded="$vuetify.breakpoint.mdAndUp ? 'xl' : 'lg'"
          :width="$vuetify.breakpoint.mdAndUp ? 750 : '100%'"
        >
          <v-card-title class="grey">
            <v-icon :size="$vuetify.breakpoint.mdAndUp ? '60' : '30'" left>
              {{ icons.mdiShieldAccount }}
            </v-icon>
            <span :class="$vuetify.breakpoint.mdAndUp ? 'text-h5' : 'text-body-1'"
              >Cari Bilgiler</span
            >
            <v-spacer />
            <v-btn
              @click="dialog = true"
              rounded
              depressed
              class="text-caption text-capitalize"
              color="chip"
            >
              <v-icon left>{{ icons.mdiLockReset }}</v-icon>
              Şifre Değiştir</v-btn
            >
          </v-card-title>

          <v-divider />

          <v-card-text>
            <v-list color="transparent">
              <v-list-item two-line class="py-2">
                <v-list-item-content>
                  <v-list-item-subtitle> Cari Unvan </v-list-item-subtitle>
                  <v-list-item-title class="text-h6">
                    {{ userData.NAME1 }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item two-line class="py-2">
                <v-list-item-content>
                  <v-list-item-subtitle> Cari Kod </v-list-item-subtitle>
                  <v-list-item-title class="text-h6">
                    {{ userData.CUSTOMER }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item two-line class="py-2">
                <v-list-item-content>
                  <v-list-item-subtitle> Cari Tip </v-list-item-subtitle>
                  <v-list-item-title class="text-h6">
                    {{ userData.CUSTTYPE }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!-- <v-divider
                class="my-3"
                style="margin-left: -20px; max-width: calc(100% + 40px) !important; width: calc(100% + 40px) !important"
              />
              <v-list-item two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiAccountCircle }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle> Kullanıcı Adı </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ userData.username }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                class="my-3"
                style="margin-left: -20px; max-width: calc(100% + 40px) !important; width: calc(100% + 40px) !important"
              />
              <v-list-item two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiLock }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle> Şifre </v-list-item-subtitle>
                  <v-list-item-title> ****** </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn color="nightDark" depressed class="text-capitalize" @click="dialog = true"> Değiştir </v-btn>
                </v-list-item-action>
              </v-list-item> -->
              <v-divider
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiMapMarker }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-1"> Adres </v-list-item-subtitle>
                  <v-list-item-title> {{ userData.ADDRESSLINE1 }} </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiCircleMedium }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-1"> Vergi Numarası </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ userData.TAXNUM }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiCircleMedium }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-1"> Vergi Dairesi </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ userData.TAXDEPT }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiAt }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-1"> E-Posta Adresi </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ userData.TLXNUM }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiPhone }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-1"> Telefon </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ userData.TELNUM }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="userData.ORDERDAYS"
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item v-if="userData.ORDERDAYS" two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiCalendar }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-1"> Sipariş Günleri </v-list-item-subtitle>
                  <v-list-item-title>
                    <v-chip-group>
                      <v-chip
                        v-for="(element, index) in orderDays(userData.ORDERDAYS)"
                        :key="`${index}-key`"
                        class="mr-2"
                        label
                        :color="
                          element === 'Cumartesi' || element === 'Pazar' ? 'warning' : 'secondary'
                        "
                        :outlined="element === 'Cumartesi' || element === 'Pazar'"
                        small
                      >
                        {{ element }}
                      </v-chip>
                    </v-chip-group>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="userData.ORDEROPENHOUR"
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item v-if="userData.ORDEROPENHOUR" two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiClock }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-1"> Sipariş Saati </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ userData.ORDEROPENHOUR.slice(0, 5) }} -
                    {{ userData.ORDERCLOSEHOUR.slice(0, 5) }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiCircleMedium }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-1"> Toplam Kredi Limiti </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ userData.CREDITLIMIT | currency }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiCircleMedium }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-1"> Çek Limit Tutarı </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ userData.CHECKLIMIT | currency }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiCircleMedium }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-1">
                    Açık Sipariş Toplam Tutarı
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ userData.SALORDER | currency }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiCircleMedium }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-1">
                    Açık İrsaliye Toplam Tutarı
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ userData.DELORDER | currency }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiCircleMedium }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-1"> Bakiye </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ userData.BALANCE | currency }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider
                class="my-3"
                style="
                  margin-left: -20px;
                  max-width: calc(100% + 40px) !important;
                  width: calc(100% + 40px) !important;
                "
              />
              <v-list-item two-line class="py-2">
                <v-list-item-avatar>
                  <v-avatar color="grey">
                    <v-icon size="24">
                      {{ icons.mdiCircleMedium }}
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="mb-1"> Kalan Limit Tutarı </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ userData.REMAINING | currency }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import store from "@/store";
import { useRouter } from "@core/utils";
import {
  mdiAccountCircle,
  mdiAt,
  mdiCalendar,
  mdiCircleMedium,
  mdiClock,
  mdiLock,
  mdiMapMarker,
  mdiPhone,
  mdiShieldAccount,
  mdiLockReset,
  mdiClose,
} from "@mdi/js";
import { postData } from "@utils";
import { onMounted, ref, watch } from "@vue/composition-api";
import Vue from "vue";

export default {
  setup() {
    const { uid } = JSON.parse(localStorage.getItem("userData"));

    const statusFind = (arr, value, select) =>
      store?.state?.tanimlar[arr].find((item) => item.value === value)[select];
    const { router } = useRouter();
    const dialog = ref(false);
    const userData = ref({});
    const loading = ref(false);
    const pageLoading = ref(true);
    const observer = ref(null);
    const oldPassword = ref(null);
    const newPassword = ref(null);
    const confirmPassword = ref(null);

    onMounted(() => {
      fetchDetail();
    });
    const fetchDetail = () => {
      const method = "getCustomerAllLimit";

      store
        .dispatch("postMethod", { method })
        .then((response) => {
          if (!response.error) {
            userData.value = response.detail;
            pageLoading.value = false;
          }
        })
        .catch((error) => {
          if (error.response.status === 404) {
            userData.value = {};
          }
        });
    };
    watch(
      () => store.state.plasiyerCustomer,
      () => {
        pageLoading.value = true;
        if (store.state.plasiyerCustomer) {
          pageLoading.value = true;
          fetchDetail();
        }
      }
    );
    const closeSubmit = () => {
      dialog.value = false;
      loading.value = false;
      oldPassword.value = null;
      newPassword.value = null;
      confirmPassword.value = null;
      observer.value.reset();
    };
    const submit = async () => {
      // loading.value = true
      // const isValid = await $refs.observer.validate()
      // if (!isValid) {
      // }

      const isValid = await observer.value.validate();
      if (isValid) {
        loading.value = true;
        postData({
          method: "memberPassUpdate",
          oldpass: oldPassword.value,
          newpass: newPassword.value,
        }).then((response) => {
          if (response.error === 1) {
            loading.value = false;
            Vue.swal({
              title: "Hata",
              text: response.msg,
              icon: "warning",
              background: "#FF4C51",
              confirmButtonColor: "#000",
            });
          } else if (response.error === 0) {
            closeSubmit();
            Vue.swal({
              title: "Başarılı",
              text: response.msg,
              icon: "success",
              background: "#56CA00",
              confirmButtonColor: "#000",
              timerProgressBar: true,
              timer: 3000,
            });
          }
        });
      }
    };

    const orderDays = (item) => {
      if (item !== null) {
        const textDays = [
          "Pazar",
          "Pazartesi",
          "Salı",
          "Çarşamba",
          "Perşembe",
          "Cuma",
          "Cumartesi",
        ];
        const days = item.split(",");

        return days.map((item) => textDays[item]);
      }
    };

    return {
      orderDays,
      statusFind,
      userData,
      loading,
      pageLoading,
      dialog,
      submit,
      oldPassword,
      newPassword,
      confirmPassword,
      observer,
      closeSubmit,
      icons: {
        mdiShieldAccount,
        mdiAccountCircle,
        mdiLock,
        mdiCircleMedium,
        mdiPhone,
        mdiAt,
        mdiMapMarker,
        mdiCalendar,
        mdiClock,
        mdiLockReset,
        mdiClose,
      },
    };
  },
};
</script>
